// extracted by mini-css-extract-plugin
export default {"faqChoiceAgent":"faqChoiceAgent_ThQDn","title":"title_WdNkw","items":"items_eBugt"};